/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConnectorStatusCount } from "./ConnectorStatusCount";
import {
    ConnectorStatusCountFromJSON,
    ConnectorStatusCountFromJSONTyped,
    ConnectorStatusCountToJSON,
} from "./ConnectorStatusCount";

/**
 *
 * @export
 * @interface ConnectorStatusByDnspResponse
 */
export interface ConnectorStatusByDnspResponse {
    /**
     *
     * @type {Array<ConnectorStatusCount>}
     * @memberof ConnectorStatusByDnspResponse
     */
    items?: Array<ConnectorStatusCount>;
}

/**
 * Check if a given object implements the ConnectorStatusByDnspResponse interface.
 */
export function instanceOfConnectorStatusByDnspResponse(
    value: object,
): value is ConnectorStatusByDnspResponse {
    return true;
}

export function ConnectorStatusByDnspResponseFromJSON(
    json: any,
): ConnectorStatusByDnspResponse {
    return ConnectorStatusByDnspResponseFromJSONTyped(json, false);
}

export function ConnectorStatusByDnspResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorStatusByDnspResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      ConnectorStatusCountFromJSON,
                  ),
    };
}

export function ConnectorStatusByDnspResponseToJSON(
    value?: ConnectorStatusByDnspResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      ConnectorStatusCountToJSON,
                  ),
    };
}
